import { mix, withAlpha } from "./color";
import type { GlassPalette, GlassPaletteInput } from "./types";

/** Near-black the brand accent is darkened toward for dims and shadows. */
const SHADE_BASE = "#05050f";

export const GLASS_DEFAULT_TINT = "#ffffff";

export const GLASS_RADIUS = {
  sheet: "28px",
  panel: "20px",
  control: "12px",
  row: "10px",
  pill: "999px",
} as const;

export const GLASS_BLUR = "blur(30px) saturate(180%)";

/**
 * Every glass colour, derived from the brand accent and a surface tint so the
 * appearance inherits whatever palette the workspace configured.
 */
export const glassPalette = ({
  accent,
  tint = GLASS_DEFAULT_TINT,
}: GlassPaletteInput): GlassPalette => {
  const shade = mix(accent, SHADE_BASE, 0.7);
  return {
    accent,
    sheet: withAlpha(tint, 0.52),
    sheetDense: withAlpha(tint, 0.86),
    sheetEdge: withAlpha(tint, 0.6),
    panel: withAlpha(tint, 0.5),
    panelEdge: withAlpha(tint, 0.55),
    inset: withAlpha(tint, 0.55),
    control: withAlpha(tint, 0.72),
    footer: `linear-gradient(to bottom, ${withAlpha(tint, 0.35)} 0%, ${withAlpha(tint, 0.9)} 60%)`,
    accentFaint: withAlpha(accent, 0.04),
    accentWash: withAlpha(accent, 0.08),
    accentWashStrong: withAlpha(accent, 0.22),
    hairline: withAlpha(shade, 0.08),
    outline: withAlpha(shade, 0.14),
    dim: withAlpha(shade, 0.3),
    shadow: `0 -18px 50px -12px ${withAlpha(shade, 0.35)}`,
    floatShadow: `0 24px 60px -18px ${withAlpha(shade, 0.45)}`,
    primaryShadow: `0 10px 24px -10px ${withAlpha(accent, 0.6)}`,
  };
};
